/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Button,
  Panel,
} from 'react-bootstrap';
import PanelToolbar from 'loracoms/PanelToolbar';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import appActions from 'loraactions/app';
import PullInterfaceRow from '../PullInterfaceRow';
import { tokensSelector } from './selectors';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  getTokens: React.PropTypes.func.isRequired,
  tokens: React.PropTypes.object.isRequired,
};

class PullInterfaces extends React.Component {

  constructor(props) {
    super(props);
    const {
      data: {
        list: tokens = [],
        mark = '',
        more = false,
      } = {},
      status = '',
    } = props.tokens;
    this.state = {
      errors: ErrorSet.createEmpty(),
      tokens,
      status,
      mark,
      more,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.apiview');
    this.handleAdd = this.handleAdd.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
  }

  componentWillMount() {
    const { getTokens, appId } = this.props;
    getTokens(appId);
  }

  componentWillReceiveProps(nextProps) {
    const { tokens } = nextProps;
    if (tokens !== this.props.tokens) {
      const {
        data: {
          mark = '',
          more = false,
        } = {},
        status,
      } = tokens;
      this.setState({ status, mark, more });
      if (status === 'success') {
        this.setState({ tokens: tokens.data.list });
      }
    }
  }

  handleAdd() {
    const { appId, getTokens } = this.props;
    callAPI({
      endpoint: 'tokens',
      body: {
        bind: appId,
      },
      method: 'POST',
    }).then(() => {
      this.setState({ reset: Math.random() });
      getTokens(appId);
    }).catch((error) => {
      this.setState({ addError: error.code });
    });
  }

  handleDelete(token) {
    const { getTokens, appId } = this.props;
    callAPI({
      endpoint: `/tokens/${token.token}`,
      method: 'DELETE',
    }).then(() => {
      this.setState({ reset: Math.random() });
      getTokens(appId);
    }).catch(() => {});
  }

  handleChangeMark(mark) {
    const { getTokens, appId } = this.props;
    getTokens(appId, { mark });
  }

  render() {
    const { appId } = this.props;
    const {
      mark = '',
      more = false,
      reset = 0,
      status = '',
      tokens,
    } = this.state;

    const addButton = (
      <Button
        bsStyle="aisz-success"
        bsSize="small"
        onClick={this.handleAdd}
      >
        <span className="halflings halflings-plus" />
        {' '}
        {this.intlMsg.msg('newtoken.btn')}
      </Button>
    );

    const trs = tokens.map((token, index) => (
      <PullInterfaceRow
        key={token.token}
        index={index}
        token={token}
        appId={appId}
        onDelete={() => this.handleDelete(token)}
      />
    ));

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('tokens.panelheader')}>
        <PanelToolbar tools={[addButton]} />
        <ShowIf if={trs.length > 0}>
          <div className={styles.tokens}>
            <div className={styles.interfaceContainer}>
              {trs}
            </div>
            <div className={styles.pager}>
              <TablePager
                mark={mark}
                more={more}
                reset={reset}
                status={status}
                onNext={this.handleChangeMark}
                onPrev={this.handleChangeMark}
              />
            </div>
          </div>
        </ShowIf>
        <ShowIf if={trs.length === 0}>
          <div className={styles.noTokens}>
            {this.intlMsg.msg('notokens')}
          </div>
        </ShowIf>
      </Panel>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  tokens: tokensSelector(ownProps.appId)(state),
});

const mapDispatchToProps = {
  getTokens: appActions.getTokens,
};

PullInterfaces.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PullInterfaces));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/PullInterfaces/index.jsx